
<template>
    <div class="guideFloating-component">
        <div
            class="btn"
            :style="{top: `${item.top}%`, right: item.right }"
            v-for="item in list"
            :key="item.key"
            @click="onFloatClick(item.key)"
            v-show="item.key !=='top' || (item.key === 'top' && isShowBtnScrollToTop)"
        >
            <i :class="`ico ${img[item.key]}`"></i>
        </div>
        <feedback
            ref="feedback"
            :params="params"
        />
    </div>
</template>

<script >
import feedback from '@/components/feedback/feedback.vue'
export default {
    name: 'guideFloating',
    components: {
        feedback
    },
    data () {
        return {
            img: {
                app_download: 'ico-icon_62', // 下载APP - 跳转app下载页面
                join_distribution: 'ico-icon_93', // 我要加入 - 跳转分销员
                top: 'ico-icon_92', // 返回顶部
                extend_explain: 'ico-icon_91', // 推广说明
                back_home: 'ico-icon_90', // 返回首页
                feedback: 'ico-icon_99', // 反馈
                sstores_in: 'ico-icon_109', // 门店入驻
            },
            animateId: null,
            scrollTop: null,
            isShowBtnScrollToTop: false, // 是否显示返回顶部按钮
        }
    },
    props: {
        list: {
            type: Array,
            default () {
                return [{
                    key: 'app_download',
                    top: '50'
                }]
            }
        },
        params: {
            type: Object,
            default: () => { }
        }
    },
    mounted () {
        /* 如果没有 返回顶部 则不绑定 */
        const top = this.list.filter((item) => {
            return item.key === 'top'
        })
        if (top.length > 0) {
            window.addEventListener('scroll', this.scrollToTop)
        }
    },
    destroyed () {
        window.removeEventListener('scroll', this.scrollToTop)
    },
    methods: {
        /**
         * 跳转下载app页面
         */
        downloadApp () {
            this.$router.push({
                path: '/appDownload',
                query: {}
            })
        },
        /*
            * 成为分销员
            */
        joinDistribution () {
            const { distribution_code } = this.$route.query
            const obj = {
                'alpha': 'http://192.168.1.206/fx-carisok',
                'beta': 'http://test-fx.carisok.com.cn',
                'abtest': 'https://abtest-fx.carisok.com.cn',
                'release': 'https://fx.carisok.com.cn'
            }
            window.location.href = `${obj[GLOBAL_API_ENV]}/#/?distribution_code=${distribution_code}`
        },
        /**
         * 返回顶部
         */
        backTop () {
            const that = this
            let timer = setInterval(() => {
                let ispeed = Math.floor(-that.scrollTop / 5)
                document.documentElement.scrollTop = document.body.scrollTop = that.scrollTop + ispeed
                if (that.scrollTop === 0) {
                    clearInterval(timer)
                }
            }, 16)
        },
        /**
         * 为了计算距离顶部的高度，当高度大于100显示回顶部图标，小于100则隐藏
         */
        scrollToTop () {
            const that = this
            let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
            that.scrollTop = scrollTop
            if (that.scrollTop > 100) {
                that.isShowBtnScrollToTop = true
            } else {
                that.isShowBtnScrollToTop = false
            }
        },
        // 反馈
        feedback () {
            this.$refs.feedback.show = true
        },
        // 门店入驻
        sstores_in () {
            window.location.href = 'https://www.carisok.net/join.html?hmsr=%E5%BE%AE%E4%BF%A1&hmpl=%E5%85%BB%E8%BD%A6H5%E5%95%86%E5%93%81%E8%AF%A6%E6%83%85-%E9%97%A8%E5%BA%97%E5%85%A5%E9%A9%BB&hmcu=%E5%85%BB%E8%BD%A6H5%E5%95%86%E5%93%81%E8%AF%A6%E6%83%85-%E9%97%A8%E5%BA%97%E5%85%A5%E9%A9%BB&hmkw=&hmci='
        },
        /**
         * 按钮被点击回调父组件
         */
        onFloatClick (type) {
            if (type === 'app_download') {
                this.downloadApp()
            } else if (type === 'join_distribution') {
                this.joinDistribution()
            } else if (type === 'top') {
                this.backTop()
            } else if (type === 'feedback') {
                this.feedback()
            } else if (type === 'sstores_in') {
                this.sstores_in()
            } else {
                this.$emit('onFloatClick', type)
            }
        },
    }
}
</script>

<style lang="stylus" scoped>
    @import '../../assets/stylus/variables'

    .guideFloating-component
        width 100%
        .btn
            position fixed
            top 60%
            right 20px
            z-index 99
</style>
